  $(document).ready(function() {
    // LOGIN SCRIPTS
    function size_check() {
      if(document.body.clientWidth < 1025) {
        if(!$('.customer-form').hasClass('form-opened')) {
          $('.customer-form').hide();
        }
        if(!$('.pro-form').hasClass('form-opened')) {
          $('.pro-form').hide();
        }
        
        $('.customer-form').hide();
        $('.pro-form').hide();
        $('.customer-header-mobile').show();
        $('.pro-header-mobile').show();
        
        $('.on-web').hide();
        $('.on-mobile').show();

        $('.pro-form').css('border', 'none');
        $('.pro-forms-container').height('110px');
      } else {
        $('.customer-form').show();
        $('.pro-form').show();
        $('.customer-header-mobile').hide();
        $('.pro-header-mobile').hide();
        
        $('.on-web').show();
        $('.on-mobile').hide();
        
        $('.pro-form').css('border-left', '1px solid rgb(26, 52, 49, .3)');
        $('.pro-forms-container').height('340px');
      }
    }
    size_check()
    document.getElementsByTagName("body")[0].onresize = function() {size_check()};

    $('.customer-header-mobile').click(function(){
      if($('.customer-form').hasClass('form-opened')) {
        $('.customer-form').slideUp(function() {
          $('.customer-header-mobile').find('.arrow-up-mobile').hide();
          $('.customer-header-mobile').find('.arrow-down-mobile').show();
        });
        $('.customer-form').removeClass('form-opened');
      } else {
        $('.customer-form').slideDown(function() {
          $('.customer-header-mobile').find('.arrow-up-mobile').show();
          $('.customer-header-mobile').find('.arrow-down-mobile').hide();
        });
        $('.customer-form').addClass('form-opened');

        if($('.pro-form').hasClass('form-opened')) {
          $('.pro-form').slideUp(function() {
            $('.pro-header-mobile').find('.arrow-up-mobile').hide();
            $('.pro-header-mobile').find('.arrow-down-mobile').show();
          });
          $('.pro-form').removeClass('form-opened');
        }
      }
    });
    $('.pro-header-mobile').click(function(){
      if($('.pro-form').hasClass('form-opened')) {
        $('.pro-form').slideUp(function() {
          $('.pro-header-mobile').find('.arrow-up-mobile').hide();
          $('.pro-header-mobile').find('.arrow-down-mobile').show();
        });
        $('.pro-form').removeClass('form-opened');
      } else {
        $('.pro-form').slideDown(function() {
          $('.pro-header-mobile').find('.arrow-up-mobile').show();
          $('.pro-header-mobile').find('.arrow-down-mobile').hide();
        });
        $('.pro-form').addClass('form-opened');
        
        if($('.customer-form').hasClass('form-opened')) {
          $('.customer-form').slideUp(function() {
            $('.customer-header-mobile').find('.arrow-up-mobile').hide();
            $('.customer-header-mobile').find('.arrow-down-mobile').show();
          });
          $('.customer-form').removeClass('form-opened');
        }
      }
    });
    // LOGIN SCRIPTS
  });